export { default } from './CategoriesGrid';
